import { useSmartProp, useEditor } from '@smartfire/js-block-engine';
import { MediaPlaceholder, MediaUploadCheck, MediaUpload } from '@wordpress/block-editor';
import React from 'react';
import style from './style.module.scss';
import { Button, ButtonGroup, IconButton } from '@wordpress/components';
export default function EditableImg(_ref) {
  let {
    smartProp,
    className = '',
    promptChangeText = "Changer l'image",
    promptPosition = 'absolute',
    ...props
  } = _ref;
  const [img, update] = useSmartProp(smartProp);
  const {
    isEditing
  } = useEditor();

  if (isEditing) {
    return React.createElement("div", {
      className: promptPosition === 'relative' ? style.editableImgRelative : style.editableImg
    }, img && img.url ? React.createElement(React.Fragment, null, React.createElement("div", {
      className: style.buttons
    }, React.createElement(MediaUploadCheck, null, React.createElement(MediaUpload, {
      onSelect: update,
      allowedTypes: ['image'],
      value: img ? img.id : null,
      render: _ref2 => {
        let {
          open
        } = _ref2;
        return React.createElement(ButtonGroup, null, React.createElement(Button, {
          isDefault: true,
          onClick: open
        }, promptChangeText), React.createElement(IconButton, {
          isDefault: true,
          isDestructive: true,
          icon: "trash",
          onClick: () => update(null)
        }));
      }
    }))), React.createElement("img", {
      className: className,
      src: img.url,
      alt: img.alt,
      ...props
    })) : React.createElement(MediaUploadCheck, null, React.createElement(MediaPlaceholder, {
      value: img && img.url ? img : {},
      onSelect: update
    })));
  } else {
    if (img && img.url) {
      return React.createElement("img", {
        className: style.image + ' ' + className,
        src: img.url,
        alt: img.alt,
        ...props
      });
    } else {
      return null;
    }
  }
}